<template>
  <div>
    <div
      ref="commentArea"
      :class="['active', 'input-comment', 'history-not__mention']"
    >
      <!-- commentInput: -->
      <div>
        <transition name="el-fade-in-linear">
          <el-input
            type="textarea"
            resize="none"
            ref="inputComment"
            :rows="3"
            placeholder="Nội dung bình luận"
            v-model="content"
            class="text-input-comment"
          ></el-input>
        </transition>
      </div>
      <!-- commentInput:end -->
      <!-- commentAttachment: -->
      <div class="action-comment flex-row flex__between">
        <div class="action-file">
          <el-upload
            ref="fileDialog"
            :action="uploadAttachmentURL"
            :headers="uploadAttachmentHeaders"
            :on-success="
              response =>
                onUploadSuccess(response).then(response =>
                  uploadAttachmentSuccess(response)
                )
            "
            :data="uploadAttachmentAdditionalData()"
            :show-file-list="false"
            :before-upload="
              file => validateUploadFile(file, { acceptFileTypes: ['*'] })
            "
            :on-error="onUploadError"
            v-loading="isUploading"
          >
            <i class="fas fa-paperclip icon-action-comment clickable"></i>
          </el-upload>
        </div>
        <div
          class="clickable btn-send-comment font-weight__bold"
          @click="insertComment"
        >
          GỬI
        </div>
      </div>
      <!-- commentAttachment:end -->
    </div>
    <transition name="slide">
      <div
        v-if="vbAttachments"
        class="group-info el-upload-list el-upload-list--text"
      >
        <div
          v-for="vbAttachment in vbAttachments"
          :key="vbAttachment.id"
          class="flex-row flex__between file-item el-upload-list__item is-success"
        >
          <div class="flex-row flex__left">
            <a @click="downloadFile(vbAttachment)" class="link-file">
              <file-type-image
                :fileExtention="vbAttachment.fileExtention"
                :customClass="'icon-mini'"
              />
              <span class="link-file clickable font-size__small">{{
                vbAttachment.fileName
              }}</span>
            </a>
          </div>
          &nbsp;
          <label class="el-upload-list__item-status-label">
            <i class="el-icon-upload-success el-icon-circle-check"></i>
          </label>
          <i
            class="el-icon-close el-tooltip item clickable font-size__small color__red"
            @click="removeVbAttachment(vbAttachment)"
          ></i>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import constants from "../../../constants";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import downloadService from "../../../services/downloadService";
  import h from "../../../services/h";
  import vbAttachmentTokenService from "../../../services/vbAttachmentTokenService";
  import uploadFileMixin from "../../doc-in/uploadFileMixin";
  import FileTypeImage from "../../job/FileTypeImage";

  export default {
    name: "base-comment-input",
    components: {FileTypeImage},
    mixins: [uploadFileMixin],

    data() {
      return {
        content: null,
        vbAttachments: []
      };
    },

    methods: {
      downloadFile(vbAttachment) {
        return downloadService.downloadFileCommon(
          vbAttachmentTokenService
            .getToken(vbAttachment.id)
            .then(response => response.data),
          constants.DOWNLOAD_FILE_URL.DEFAULT_URL
        );
      },

      uploadAttachmentAdditionalData() {
        return {objectType: constants.ATTACHMENT_OBJECT_TYPE.COMMENT};
      },

      uploadAttachmentSuccess(vbAttachment) {
        this.vbAttachments.push(vbAttachment);
      },

      convertToSubmitCommentForm() {
        return {
          content: this.content,
          attachmentIds: h.collect(this.vbAttachments, item => item.id)
        };
      },

      resetFormAfterSubmitComment() {
        this.content = "";
        this.vbAttachments = [];
      },

      insertComment() {
        return this.validateCommentForm().then(() => {
          this.$emit("insertComment", this.convertToSubmitCommentForm());
        });
      },

      removeVbAttachment(vbAttachment) {
        this.vbAttachments.splice(this.vbAttachments.indexOf(vbAttachment), 1);
      },

      validateCommentForm() {
        return new Promise(resolve => {
          if (!this.content || !this.content.trim()) {
            this.$message.error(
              errorMessageFilter({errorCode: "tkTask.comment.contentRequired"})
            );
          } else {
            resolve();
          }
        });
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/base-comment-input.vue